import { render, staticRenderFns } from "./IntendedUserEditModal.vue?vue&type=template&id=3b795c36&scoped=true&"
import script from "./IntendedUserEditModal.vue?vue&type=script&lang=js&"
export * from "./IntendedUserEditModal.vue?vue&type=script&lang=js&"
import style0 from "./IntendedUserEditModal.vue?vue&type=style&index=0&id=3b795c36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b795c36",
  null
  
)

export default component.exports